import React from 'react';
import CountrySelect from '../components/CountrySelect';
import { validStates } from './PatientInfoForm';
import GoogleAddressInputForm from './GoogleAddressInputForm';

/**
 * The international version of the patient address form.
 * SCR-7140: The major difference is the county field is not used and other fields are resized to fill in the extra space.
 */
export default function InternationalAddressInputForm({
	covidRegistration,
	disabled,
	fullRegistrationRequired,
	form,
	onChangeHandlers,
	isInternational,
	handleShippingChange,
	addressLookupEnabled,
	userInfo,
	ukClient
}) {

	if (!form) {
		return null;
	}

	return (
		<>
			<div className="row">
				<div className={'form-group col-md-6 ' + (form.address1?.valid === false ? 'has-error' : '')}>
					<label className="control-label" htmlFor="patient-address1">
						Address 1{fullRegistrationRequired && <span className="text-danger">*</span>}
					</label>
					{addressLookupEnabled === true ?
							(<GoogleAddressInputForm
									form={form}
									fullRegistrationRequired={fullRegistrationRequired}
									isInternational={isInternational}
									handleShippingChange={handleShippingChange}
									onChangeHandlers={onChangeHandlers}
									userInfo={userInfo}
							/>) :
							<input
									className="form-control"
									name="patientAddress"
									id="patient-address1"
									maxLength="128"
									type="text"
									value={form.address1?.value || ''}
									onChange={onChangeHandlers?.address1}
									autoComplete="new-password"
									disabled={disabled}
							></input>
					}
					{form.address1?.valid === false && (
						<span className="validation-message text-danger">{form.address1?.message}</span>
					)}
				</div>
				<div className={'form-group col-md-6 ' + (form.address2?.valid === false ? 'has-error' : '')}>
					<label className="control-label" htmlFor="patient-address2">
						Address 2
					</label>
					<input
						className="form-control"
						name="patientAddress"
						id="patient-address2"
						maxLength="128"
						type="text"
						value={form.address2?.value || ''}
						onChange={onChangeHandlers?.address2}
						autoComplete="new-password"
						disabled={disabled}
					></input>
					{form.address2?.valid === false && (
						<span className="validation-message text-danger">{form.address2?.message}</span>
					)}
				</div>
			</div>
			<div className="row">
				<div className={'form-group col-md-3 ' + (form.city?.valid === false ? 'has-error' : '')}>
					<label className="control-label" htmlFor="patient-city">
						City
						{fullRegistrationRequired && <span className="text-danger">*</span>}
					</label>
					<input
						className="form-control"
						name="patientAddress"
						id="patient-city"
						maxLength="64"
						type="text"
						value={form.city?.value || ''}
						onChange={onChangeHandlers?.city}
						autoComplete="new-password"
						disabled={disabled}
					></input>
					{form.city?.valid === false && (
						<span className="validation-message text-danger">{form.city?.message}</span>
					)}
				</div>
				{!ukClient && (<div className={'form-group col-md-3 ' + (form.state?.valid === false ? 'has-error' : '')}>
					<label className="control-label" htmlFor="patient-state">
						State/Province
						{(fullRegistrationRequired && !ukClient) && <span className="text-danger">*</span>}
					</label>
					<input
						className="form-control"
						name="patientAddress"
						id="patient-state"
						maxLength="32"
						style={{ paddingLeft: '5px', paddingRight: '5px' }}
						type="select"
						list="states"
						pattern={validStates}
						value={form.state?.value || ''}
						onChange={onChangeHandlers?.state}
						autoComplete="new-password"
						disabled={disabled}
					></input>
					{form.state?.valid === false && (
						<span className="validation-message text-danger">{form.state?.message}</span>
					)}
				</div>)}
				<div className={'form-group col-md-3 ' + (form.zipCode?.valid === false ? 'has-error' : '')}>
					<label className="control-label" htmlFor="patient-zip">
						Postal Code
						{fullRegistrationRequired && <span className="text-danger">*</span>}
					</label>
					<input
						className="form-control"
						name="patientAddress"
						id="patient-zipCode"
						maxLength="10"
						type="text"
						value={form.zipCode?.value || ''}
						onChange={onChangeHandlers?.zipCode}
						autoComplete="new-password"
						disabled={disabled}
					></input>
					{form.zipCode?.valid === false && (
						<span className="validation-message text-danger">{form.zipCode?.message}</span>
					)}
				</div>

				<div className={'form-group col-md-3 ' + (form.country?.valid === false ? 'has-error' : '')}>
					<label className="control-label" htmlFor="patient-country">
						Country
						{fullRegistrationRequired && <span className="text-danger">*</span>}
					</label>
					<CountrySelect
						selectedCountry={form.country?.value || ''}
						name="patientAddress"
						id="patient-country"
						onChange={onChangeHandlers?.country}
						disabled={disabled}
						ukOrder={ukClient}
					/>
					{form.country?.valid === false && (
						<span className="validation-message text-danger">{form.country?.message}</span>
					)}
				</div>
			</div>
		</>
	);
}
